import React, {useEffect} from 'react';
import Common from "./common";
import store from "../../storeWire";
import {setData} from "../../store/slice/customerAccount";
import axios from "axios";
import Helper from "../../application/helper";
import {usePage} from "@inertiajs/inertia-react";

const Edit = () => {
    const p = usePage();
    useEffect(() => {
        axios.get(Helper.route('customeraccount.show', {
            customeraccount: p.props.customer_account
        })).then((res) => {
            if (res.data.data.id !== undefined && res.data.data.id) {
                store.dispatch(setData(res.data.data));
            } else {
                window.location.href = Helper.route('customer-account.index');
            }
        }).catch(() => {
            window.location.href = Helper.route('customer-account.index');
        });
    }, []);
    return <><Common/></>;
}

export default Edit;
